import TrustBanner from "@/components/site/TrustBanner";
import FeaturedTestimonials from "@/components/site/FeaturedTestimonials";
import HighlightQuotes from "@/components/site/HighlightQuotes";
import RecurringThemes from "@/components/site/RecurringThemes";
import CommunityImpact from "@/components/site/CommunityImpact";
import VideoTestimonials from "@/components/site/VideoTestimonials";
import CategoryReviews from "@/components/site/CategoryReviews";
import ReviewGallery from "@/components/site/ReviewGallery";
import TrustFinalCTA from "@/components/site/TrustFinalCTA";
import usePageTitle from "@/hooks/usePageTitle";

export default function TestimonialsPage() {
  usePageTitle("Testimonials · Trusted by Pilgrims Worldwide");
  return (
    <div data-testid="page-testimonials">
      <div className="pt-16 md:pt-20">
        <TrustBanner />
        <FeaturedTestimonials />
        <HighlightQuotes />
        <CategoryReviews />
        <RecurringThemes />
        <CommunityImpact />
        <VideoTestimonials />
        <ReviewGallery />
        <TrustFinalCTA />
      </div>
    </div>
  );
}
